"use client";

import type { ComponentProps } from "react";
import { motion, useAnimation } from "framer-motion";
import { lookEntrance } from "./LookMotion";

/**
 * The framer entrances old websites keep, in one module so the files that use them import no framer. Inside a
 * look-system section lookEntrance() renders a plain element instead, so no framer code runs there.
 */
export const EntranceDiv = lookEntrance(motion.div, "div");
export const EntranceSection = lookEntrance(motion.section, "section");

/** An entrance under framer's animation controls, created inside it so the look system never calls the hook. */
function controlled<Tag extends typeof motion.div | typeof motion.section>(
  Moving: Tag,
) {
  return function Controlled(props: ComponentProps<Tag>) {
    const controls = useAnimation();
    const Element = Moving as typeof motion.div;
    return (
      <Element
        animate={controls}
        {...(props as ComponentProps<typeof motion.div>)}
      />
    );
  };
}

export const ControlledEntranceDiv = lookEntrance(
  controlled(motion.div),
  "div",
);
export const ControlledEntranceSection = lookEntrance(
  controlled(motion.section),
  "section",
);
